import { PartnerIdentifier } from '@sales-domain/product-config';
import { HeaderLogo } from './HeaderLogo';
import { StyledHeaderContentContainer } from './elements';

import AsurionLogo from 'public/images/asurion-logo.svg';
import GamestopAsurionLogo from 'public/images/gamestop-asurion-logo.svg';
import React from 'react';

type Props = {
  partnerIdentifier?: PartnerIdentifier;
  children?: React.ReactNode;
};

const determineLogo = (partnerIdentifier?: PartnerIdentifier): JSX.Element => {
  switch (partnerIdentifier) {
    case PartnerIdentifier.GameStop:
      return GamestopAsurionLogo;
    default:
      return AsurionLogo;
  }
};

export const Header = ({ children, partnerIdentifier }: Props) => {
  const logo = determineLogo(partnerIdentifier);

  return (
    <div className="border-b-neutral-brightest flex border-b border-l-0 border-r-0 border-t-0 border-solid bg-white md:justify-center">
      <header className="flex w-full bg-white text-black md:max-w-[1440px]">
        <div className="grid w-full grid-cols-[150px_auto] px-4 py-4 lg:px-12 xl:px-12">
          <div className="flex items-center">
            <HeaderLogo logoSrc={logo} />
          </div>
          {children && (
            <StyledHeaderContentContainer>
              {children}
            </StyledHeaderContentContainer>
          )}
        </div>
      </header>
    </div>
  );
};
